import { useApp } from '../../state/AppContext';
import Icon from '../../lib/Icon';
import { badge, riskColor, zebra } from '../../lib/format';
import { cardPad, Th } from '../../lib/ui';

export default function Fraud() {
  const { go, L } = useApp();

  const fraudKpis = [
    { label: L('Open Flags', 'การแจ้งเตือนที่เปิดอยู่'), value: '3', color: 'var(--color-error)' },
    { label: L('Collusion Alerts', 'การแจ้งเตือนการสมรู้ร่วมคิด'), value: '2', color: 'var(--color-error)' },
    { label: L('Split Order Flags', 'การแจ้งเตือนการแบ่งย่อยคำสั่งซื้อ'), value: '1', color: 'var(--color-warning)' },
    { label: L('RPT Transactions', 'รายการที่เกี่ยวโยงกัน'), value: '2', color: 'var(--color-error)' },
  ];

  const ff = [
    { id: 'FF-2026-0018', type: L('Collusion', 'การสมรู้ร่วมคิด'), sev: 'High', ref: 'RFQ-2026-004', risk: 72, sup: 'SUP-002, SUP-005', detected: '2026-06-08', status: 'Open' },
    { id: 'FF-2026-0016', type: 'RPT', sev: 'High', ref: 'PO-2026-0035', risk: 64, sup: 'SUP-004', detected: '2026-06-05', status: 'Under Investigation' },
    { id: 'FF-2026-0012', type: L('Split Order', 'การแบ่งย่อยคำสั่งซื้อ'), sev: 'Medium', ref: 'PR-2026-0187', risk: 38, sup: 'GeoTrack Solutions', detected: '2026-05-28', status: 'Under Investigation' },
  ];
  const fraudRows = ff.map((f, i) => {
    const b = badge(f.status);
    const sev = badge(f.sev);
    return { ...f, zebra: zebra(i), stBg: b.bg, stFg: b.fg, sevBg: sev.bg, sevFg: sev.fg, riskColor: riskColor(f.risk), riskW: f.risk + '%' };
  });

  return (
    <>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: 16, marginBottom: 16 }}>
        {fraudKpis.map((k) => (
          <div key={k.label} style={cardPad(18)}>
            <div style={{ fontSize: 11, fontWeight: 700, textTransform: 'uppercase', color: 'var(--color-fg-3)', marginBottom: 8 }}>{k.label}</div>
            <div style={{ fontSize: 28, fontWeight: 700, fontFamily: 'var(--font-mono)', color: k.color }}>{k.value}</div>
          </div>
        ))}
      </div>

      <div style={{ ...cardPad(20), marginBottom: 16 }}>
        <div style={{ fontSize: 11, fontWeight: 700, textTransform: 'uppercase', color: 'var(--color-fg-3)', marginBottom: 10 }}>{L('Override Rate This Period', 'อัตราการแทนที่ในงวดนี้')}</div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 20 }}>
          <div style={{ fontSize: 34, fontWeight: 700, fontFamily: 'var(--font-mono)' }}>8.3%</div>
          <div style={{ flex: 1 }}>
            <div style={{ height: 10, borderRadius: 999, background: 'var(--color-ink-50)', overflow: 'hidden' }}>
              <div style={{ height: '100%', width: '83%', background: 'var(--color-warning)' }} />
            </div>
            <div style={{ fontSize: 12, color: 'var(--color-fg-3)', marginTop: 6 }}>{L('Target: <5% · 2 overrides recorded this period.', 'เป้าหมาย: <5% · บันทึกการแทนที่ 2 ครั้งในงวดนี้')}</div>
          </div>
        </div>
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginTop: 14 }}>
          <button onClick={() => go('override')} className="hv-ink" style={{ display: 'flex', alignItems: 'center', gap: 6, padding: '8px 13px', border: '1px solid var(--color-border-strong)', borderRadius: 'var(--radius-sm)', fontSize: 12, fontWeight: 600, background: 'var(--color-white)' }}>
            <Icon name="git-branch" />{L('Override Log', 'บันทึกการแทนที่')}
          </button>
          <button onClick={() => go('rpt')} className="hv-ink" style={{ display: 'flex', alignItems: 'center', gap: 6, padding: '8px 13px', border: '1px solid var(--color-border-strong)', borderRadius: 'var(--radius-sm)', fontSize: 12, fontWeight: 600, background: 'var(--color-white)' }}>
            <Icon name="link-2" />{L('RPT Report', 'รายงานรายการที่เกี่ยวโยงกัน')}
          </button>
          <button onClick={() => go('network')} className="hv-ink" style={{ display: 'flex', alignItems: 'center', gap: 6, padding: '8px 13px', border: '1px solid var(--color-border-strong)', borderRadius: 'var(--radius-sm)', fontSize: 12, fontWeight: 600, background: 'var(--color-white)' }}>
            <Icon name="share-2" />{L('Network Graph', 'กราฟเครือข่าย')}
          </button>
          <button onClick={() => go('wbcases')} className="hv-ink" style={{ display: 'flex', alignItems: 'center', gap: 6, padding: '8px 13px', border: '1px solid var(--color-border-strong)', borderRadius: 'var(--radius-sm)', fontSize: 12, fontWeight: 600, background: 'var(--color-white)' }}>
            <Icon name="megaphone" />{L('Whistleblower Cases', 'คดีผู้แจ้งเบาะแส')}
          </button>
        </div>
      </div>

      <div style={cardPad(0, 'auto')}>
        <div style={{ padding: '14px 18px', fontWeight: 700, borderBottom: '1px solid var(--color-border)' }}>{L('Recent Fraud Flags', 'การแจ้งเตือนการทุจริตล่าสุด')}</div>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13, minWidth: 900 }}>
          <thead>
            <tr style={{ background: 'var(--color-mist)', borderBottom: '1px solid var(--color-border)' }}>
              <Th>{L('Flag ID', 'รหัสการแจ้งเตือน')}</Th>
              <Th>{L('Type', 'ประเภท')}</Th>
              <Th>{L('Severity', 'ระดับความรุนแรง')}</Th>
              <Th>{L('Reference', 'อ้างอิง')}</Th>
              <Th>{L('Risk Score', 'คะแนนความเสี่ยง')}</Th>
              <Th>{L('Affected', 'ได้รับผลกระทบ')}</Th>
              <Th>{L('Status', 'สถานะ')}</Th>
            </tr>
          </thead>
          <tbody>
            {fraudRows.map((f) => (
              <tr key={f.id} style={{ borderBottom: '1px solid var(--color-border)', background: f.zebra }}>
                <td style={{ padding: '11px 16px', fontFamily: 'var(--font-mono)', fontWeight: 600 }}>{f.id}</td>
                <td style={{ padding: '11px 16px' }}>{f.type}</td>
                <td style={{ padding: '11px 16px' }}>
                  <span style={{ fontSize: 11, fontWeight: 600, padding: '3px 10px', borderRadius: 999, background: f.sevBg, color: f.sevFg }}>{f.sev}</span>
                </td>
                <td style={{ padding: '11px 16px', fontFamily: 'var(--font-mono)', color: 'var(--color-fg-2)' }}>{f.ref}</td>
                <td style={{ padding: '11px 16px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <div style={{ width: 60, height: 6, borderRadius: 999, background: 'var(--color-ink-50)', overflow: 'hidden' }}>
                      <div style={{ height: '100%', width: f.riskW, background: f.riskColor }} />
                    </div>
                    <span style={{ fontFamily: 'var(--font-mono)', fontWeight: 600, color: f.riskColor }}>{f.risk}</span>
                  </div>
                </td>
                <td style={{ padding: '11px 16px', fontFamily: 'var(--font-mono)', fontSize: 12, color: 'var(--color-fg-2)' }}>{f.sup}</td>
                <td style={{ padding: '11px 16px' }}>
                  <span style={{ fontSize: 11, fontWeight: 600, padding: '3px 10px', borderRadius: 999, background: f.stBg, color: f.stFg }}>{f.status}</span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
}
